<template>
    <div :class="navigateButtons && 'p-ai-center p-grid p-jc-center'">
    <div
            :class="navigateButtons && 'p-col'"
        >
        <div :class="navigateButtons && 'p-inputgroup'">
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'המקצוע הקודם'"
                        @click="navigateDays(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        v-on="listeners"
                        :filter="true"
                        filterPlaceholder="חפש מקצוע"
                        emptyFilterMessage=" לא נמצא מקצוע"
                        placeholder="מקצוע"
                        data-key="id"
                        :key="DropdownKey"
                        dataKey="id"
                        optionLabel="hebrewName"
                        v-model="selectLesson"
                        :options="getLessons"
                        @change="onSelect"
                >
                </Dropdown>

                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'המקצוע הבא'"
                        @click="navigateDays(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";

export default {
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        navigateButtons:{
            type: Boolean,
            default: false
        },
        useStore:{
            type: Boolean,
            default: false
        },
        defaultValue:{
            type: String,
            default: null
        },
        specificOptions:{
            type: Array,
            default: null
        },
        value: null
    },
    name: "SelectLesson",
    data: () => ({
        selectLesson: null,
        DropdownKey: 1
    }),
    methods: {
        onSelect({originalEvent, value}) {
            if(this.useStore){
                Vue.ls.set(`selectLesson_${this.storageName}`, value)
            }
            this.selectLesson = value
            this.$emit('onSelect', value);
            this.$emit('input', value);

        },
        navigateDays(isAdd) {
            const index = this.getLessons.findIndex(
                (day) => day.id === this.selectLesson.id
            );
            const subject =
                this.getLessons[
                ((isAdd ? index + 1 : index - 1) + this.getLessons.length) %
                this.getLessons.length
                    ];
            this.onSelect({originalEvent: null, value: subject})

        },
    },
    computed: {
        getLessons() {
            if (this.specificOptions){
                const specificLessons = this.subjectLesson?.filter((lesson) => {
                    return  this.specificOptions.includes(lesson.id)
                })
                console.log("specificLessons", specificLessons  )
                return specificLessons
            }
            return this.subjectLesson ?? []

        },

        listeners() {
            return {
                ...this.$listeners,
                input: event => {
                    this.$emit('input', event?.target?.value);
                }
            };
        },
        ...mapState([ "subjectLesson"]),
    },
    watch: {
        selectLesson(newValue, oldValue) {
        }
    },
    created() {
        if (this.useStore) {
            const restoreSubject = Vue.ls.get(`selectLesson_${this.storageName}`)

            if (restoreSubject && this.subjectLesson.some(g => g.id === restoreSubject.id)){
                this.onSelect({originalEvent: null, value: restoreSubject})
            } else {
                if (this.defaultFirst){
                    this.onSelect({originalEvent: null, value: this.subjectLesson[0]})
                }
            }
        }  else {
            if (this.defaultFirst){
                this.onSelect({originalEvent: null, value: this.subjectLesson[0]})
            }
        }
        // if (this.defaultValue !== null){
        //
        //     const defaultValueFind = this.subjectLesson?.find(lesson => {
        //         if (lesson.id === this.defaultValue) {
        //
        //             return lesson.id === this.defaultValue
        //         }
        //     })
        //
        //     this.selectLesson = defaultValueFind
        //     // this.onSelect()
        // }
        // else if(this.useStore) {
        //     this.selectLesson = Vue.ls.get(`selectLesson_${this.storageName}`) || {id: 0}
        //     this.onSelect()
        // }
    }
}
</script>

<style scoped>

</style>